import React from 'react';
import CountUp from './CountUp';
import { performanceStats } from '../lib/liveData';

export default function StatsSection() {
  return (
    <section id="stats" className="relative max-w-7xl mx-auto px-5 md:px-8 py-12">
      <div className="reveal glass-strong rounded-3xl p-8 md:p-10">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 md:gap-4 divide-y md:divide-y-0 md:divide-x divide-white/8">
          {performanceStats.map((s) => (
            <div key={s.label} className="text-center px-2 pt-4 md:pt-0 first:pt-0">
              <div className="font-display text-3xl md:text-4xl font-bold text-gradient">
                <CountUp end={s.value} suffix={s.suffix} />
              </div>
              <div className="mt-2 text-xs md:text-sm text-slate-500">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
